import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CreateTagsSchema, DataResponse, TagsResponseDataSchema } from "schema"
import { z } from "zod"
import { getTagsQueryKey } from "../lib/tagsQuery"

type Params = z.infer<typeof CreateTagsSchema>
type Response = DataResponse<z.infer<typeof TagsResponseDataSchema>>

export function useCreateTagsMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await axios.post<Response>("/customers/tags", params)
      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getTagsQueryKey() })
    },
  })
}
